import { render, staticRenderFns } from "./TituloBoletim.vue?vue&type=template&id=3f606866&"
import script from "./TituloBoletim.vue?vue&type=script&lang=js&"
export * from "./TituloBoletim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports